import { FluxonosUtils, RequestMethodEnum } from '@fluxonos/fluxonos-dto';
import { IApiEndpoint } from '@fluxonos/features/shared/interfaces/api-endpoint.interface';
import { isEnum } from 'class-validator';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { filter, firstValueFrom, startWith, take } from 'rxjs';
import { environment } from '@fluxonos/environments/environment';

const urlBuilderCache: { [key: string]: IApiEndpoint } = {};

export class NgFluxonosUtils {
  public static urlBuilder(env: any): (propertyPath: string, ...params: any[]) => IApiEndpoint {
    return (propertyPath: string, ...params: any[]): IApiEndpoint => {
      const key = `URL_BUILDER__${propertyPath}__${params.join('__')}`;

      const cached = urlBuilderCache[key];
      if (cached) {
        return cached;
      }

      let item = env;

      let section: string[] = [];
      let method: RequestMethodEnum | undefined;
      let header: { [header: string]: string | string[] } | undefined;

      // default domain from environment
      if (!!environment.apiUrl) {
        let domain = `${environment.apiUrl}`;
        if (!!environment.apiPort) {
          domain = `${item.url}:${environment.apiPort}`;
        }
        section.push(domain);
      }

      for (const key of propertyPath.split('.')) {
        item = item[key];

        // domain
        if (!!item.url) {
          let domain = `${item.url}`;
          if (!!item.port) {
            domain = `${item.url}:${item.port}`;
          }
          section.push(domain);
          continue;
        }

        // path
        if (!!item.endPoint) {
          if (typeof item.endPoint === 'function') {
            const count = item.endPoint.length;
            section.push(item.endPoint(...params.splice(0, count)));
          } else {
            section.push(item.endPoint);
          }
        }

        // method
        if (!!item.method && isEnum(item.method, RequestMethodEnum)) {
          method = item.method;
        }

        // header
        if (!!item.header) {
          header = item.header;
        }
      }

      if (!method) {
        throw new Error(`method not exists in propertyPath '${propertyPath}'`);
      }

      if (!header) {
        throw new Error(`header not exists in propertyPath '${propertyPath}'`);
      }

      urlBuilderCache[key] = { url: FluxonosUtils.cleanUpUrl(section.join('/')), method: method, header: header };

      return urlBuilderCache[key];
    };
  }

  public static async updateValueAndValidity(value: FormGroup): Promise<any> {
    for (const key in value.controls) {
      if (!value.controls.hasOwnProperty(key)) {
        continue;
      }
      const control = value.controls[key];
      if (control instanceof FormControl) {
        control.markAsDirty();
        control.markAsTouched();
        // control.clearAsyncValidators();
        control.updateValueAndValidity();

        await firstValueFrom(
          value.statusChanges.pipe(
            startWith(value.status),
            filter((status: string) => status !== 'PENDING'),
            take(1)
          )
        );
      } else if (control instanceof FormArray) {
        (control.controls as FormGroup[]).map(async (item: FormGroup) => {
          await this.updateValueAndValidity(item);
        });
      } else if (control instanceof FormGroup) {
        await this.updateValueAndValidity(control);
      }
    }
  }
}
